import { BottomNavigation, BottomNavigationAction, Box, TextField, Tooltip } from '@mui/material';
import List from 'widgets/list/list';
import styles from 'pages/insured-persons/InsuredPersons.module.css';
import { useAppDispatch, useAppSelector } from 'shared/utils/hooks/useRedux';
import { useForm } from 'shared/utils/hooks/useForm';
import { useNavigate } from 'react-router-dom';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { CurrentPagePolicies, Download, ErrorDownload, FileData, FileName, InsuredPersonsList, LoadingPolicies } from 'entities/insured-persons/selector';
import { fetchInsuredPersonsList, fetchPoliciesDownload } from 'entities/insured-persons/actions/fetch-insured-persons';
import { resetFileData, setCurrentPageInsuredPersons } from 'entities/insured-persons';
import AllContractsList from 'widgets/all-contracts-list/AllContractsList';
import TransferList from 'widgets/field-settings/FieldSettings';

import SettingsIcon from '@mui/icons-material/Settings';
import ModalWidget from 'widgets/modal/Modal';
import { allFields, defaultFields, fieldMappings } from 'features/insured-persons/utils/constant';
import { IPolicies } from 'entities/insured-persons/types/InsuredPersons-interface';
import SearchIcon from '@mui/icons-material/Search';

import appStyles from 'app/providers/theme/App.module.css';
import CustomButton from 'shared/custom-button/CustomButton';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import Loader from 'shared/loader/Loader';
import { AlertMessage } from 'shared/alert-message/alert-message';

interface IInsuredPersons {
    isContract?: boolean;
    idContract?: string[];
}

interface IAlertInfo {
    message?: string;
    severity?: string;
}

export const InsuredPersons: FC<IInsuredPersons> = ({ isContract, idContract }) => {
    const limit = 10;

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const insuredPersons = useAppSelector(InsuredPersonsList);
    const currentPage = useAppSelector(CurrentPagePolicies);
    const isLoading = useAppSelector(LoadingPolicies);

    const selectedContracts = {
        list: [],
    };

    const {
        formData,
        handleAutocompeteChange
    } = useForm(selectedContracts);

    const [selectedOptions, setSelectedOptions] = useState(0);
    const [isUserAction, setIsUserAction] = useState(false);
    const [contractID, setContractID] = useState<string | string[]>([]);
    const [fields, setFields] = useState<string[]>(defaultFields);
    const [tempFields, setTempFields] = useState<string[]>(fields);
    const [open, setOpen] = useState(false);

    const sortArray: string[] | [] = ['ID'];
    const [openSearch, setOpenSearch] = useState(false);
    const [searchQuery, setSearchQuery] = useState<string>('');

    const [alertInfo, setAlertInfo] = useState<IAlertInfo>({ message: '', severity: '' });

    const [downloadTriggered, setDownloadTriggered] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);

    const handleOpenSearch = () => setOpenSearch((prevState) => !prevState);


    const fileData = useAppSelector(FileData);
    const fileName = useAppSelector(FileName);
    const isDownload = useAppSelector(Download);
    const errorDownload = useAppSelector(ErrorDownload);

    const currentFilters = useMemo(() => {
        return selectedOptions === 0 ? [] : [];
    }, [selectedOptions]);

    const [isInitialMount, setIsInitialMount] = useState(true);

    useEffect(() => {
        if (isInitialMount) {
            setIsInitialMount(false);
            return;
        }

        const offset = limit * (currentPage - 1);
        const contract = idContract ? idContract : (Array.isArray(contractID) ? contractID : [contractID]);
        dispatch(fetchInsuredPersonsList({ contractID: contract, sortArray, filters: currentFilters }));

    }, [dispatch, limit, contractID]);

    const handleChildAction = useCallback((page: number) => {
        dispatch(setCurrentPageInsuredPersons({ page }));
    }, [dispatch]);

    const handleSearchChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(e.target.value);
        dispatch(setCurrentPageInsuredPersons({ page: 1 }));
    }, [dispatch]);

    // const filteredInsuredPersons = useMemo(() => {
    //     let filteredData = [...insuredPersons];
    //     if (selectedOptions !== 0) {
    //         filteredData = filteredData.filter(person => person.Active === (selectedOptions === 1));
    //     }
    //     if (searchQuery) {
    //         filteredData = filteredData.filter((item: IPolicies) =>
    //             item.PolicyNumber.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //             item.FullName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //             item.InsuranceProgramPrintName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //             item.InsurerName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //             item.StartDate.includes(searchQuery)
    //         );
    //     }
    //     return filteredData;
    // }, [selectedOptions, insuredPersons, searchQuery]);

    // const paginatedInsuredPersons = useMemo(() => {
    //     const startIndex = (currentPage - 1) * limit;
    //     return filteredInsuredPersons.slice(startIndex, startIndex + limit);
    // }, [currentPage, filteredInsuredPersons]);

    const filteredInsuredPersons = (() => {
        let filteredData = [...insuredPersons];
        if (selectedOptions !== 0) {
            filteredData = filteredData.filter(person => person.Active === (selectedOptions === 1));
        }
        if (searchQuery) {
            filteredData = filteredData.filter((item: IPolicies) =>
                item.PolicyNumber.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.FullName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.InsuranceProgramPrintName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.InsurerName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.StartDate.includes(searchQuery)
            );
        }
        return filteredData;
    })();

    const paginatedInsuredPersons = () => {
        const startIndex = (currentPage - 1) * limit;
        return filteredInsuredPersons.slice(startIndex, startIndex + limit);
    };

    const renderItem = (item: any) => (
        <>
            {fields.map((field) => {
                const key = fieldMappings[field];
                if (key === 'StartDateEndDate') {
                    return (
                        <Box key={field}>
                            <p>{`${item.StartDate} - ${item.EndDate}`}</p>
                        </Box>
                    );
                } else if (key === 'Active') {
                    return (
                        <Box key={field}>
                            <p>{item[key] ? 'Прикреплен' : 'Откреплен'}</p>
                        </Box>
                    );
                } else {
                    return (
                        <Box key={field}>
                            <p>{item[key]}</p>
                        </Box>
                    );
                }
            })}
        </>
    );

    const handleOpen = () => {
        setTempFields(fields);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleReset = () => {
        setTempFields(defaultFields);
    };

    const handleAccept = () => {
        setFields(tempFields);
        setOpen(false);
    };

    const handleTempFieldsChange = (newFields: string[]) => {
        setTempFields(newFields);
    };

    const handleFileDownload = async (filters: any) => {
        setAlertInfo({ message: '', severity: '' });

        try {
            setIsDownloading(true);

            await dispatch(fetchPoliciesDownload({
                Filters: filters
            }));

            setDownloadTriggered(true);
        } catch (error) {
            console.error('Error downloading the file:', error);
        } finally {
            setIsDownloading(false);
        }
    };

    useEffect(() => {
        if (downloadTriggered && fileData && errorDownload.length === 0) {
            const link = document.createElement('a');
            link.href = `data:application/octet-stream;base64,${fileData}`;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            dispatch(resetFileData());
            setDownloadTriggered(false);
        } else if (errorDownload.length > 0) {
            setAlertInfo({ message: errorDownload[0].Msg, severity: 'error' });
            const timeoutId = setTimeout(() => {
                setAlertInfo({ message: '', severity: '' });
                dispatch(resetFileData());
            }, 3000);
            return () => clearTimeout(timeoutId);
        }
    }, [downloadTriggered, fileData, errorDownload, fileName, dispatch]);

    const excelDownload = async () => {
        const ids = filteredInsuredPersons.map(object => object.ID);
        const filters = [{
            "Field": "ID",
            "ComparisonType": "IN",
            "Value": ids
        }];

        await handleFileDownload(filters);
    };

    return (
        <>
            {!isContract && (
                <>
                    {alertInfo.message && (
                        <Box className={appStyles.alertBox}>
                            <AlertMessage alertInfo={alertInfo} />
                        </Box>
                    )}
                    <Box className={appStyles.titleBox}>
                        <h1>Застрахованные</h1>
                    </Box>
                    <AllContractsList
                        formData={formData}
                        handleAutocompeteChange={handleAutocompeteChange}
                        setContractID={setContractID}
                        multiple={true}
                        name="list"
                        reducerAction={setCurrentPageInsuredPersons}
                        disabled={isLoading || isDownload}
                    />
                    {isDownload && (
                        <Loader
                            title='Файл скачивается... Пожалуйста, подождите'
                        />
                    )}

                    <Box className={styles.btnContainer}>
                        {!isLoading && !isDownload && (
                            <>
                                {insuredPersons.length > 0 && (
                                    <Tooltip title="Выгрузить в Excel" placement="top">
                                        <Box>
                                            <CustomButton
                                                icon={FileDownloadIcon}
                                                handleClick={excelDownload}
                                                textColor='white'
                                                backgroundColor="#0054E6"
                                                border='none'
                                                borderRadius='4px'
                                                padding="8px 30px"
                                                disabled={false}
                                            />
                                        </Box>
                                    </Tooltip>
                                )}

                                <Box className={styles.btnNavigation}>
                                    <BottomNavigation
                                        showLabels
                                        value={selectedOptions}
                                        onChange={(event, newValue) => {
                                            setSelectedOptions(newValue);
                                            setIsUserAction(true);
                                        }}
                                        sx={{
                                            backgroundColor: 'transparent',
                                        }}
                                    >
                                        <BottomNavigationAction label="Весь список" sx={{
                                            '&.Mui-selected': {
                                                color: '#0054E6 !important',
                                            },
                                        }} />
                                        <BottomNavigationAction label="Прикрепленные" sx={{
                                            '&.Mui-selected': {
                                                color: '#0054E6 !important',
                                            },
                                        }} />
                                        <BottomNavigationAction label="Открепленные" sx={{
                                            '&.Mui-selected': {
                                                color: '#0054E6 !important',
                                            },
                                        }} />
                                    </BottomNavigation>
                                    <Tooltip title="Настройка таблицы" placement="top">
                                        <span
                                            className={styles.iconContract}
                                            onClick={() => handleOpen()}
                                        >
                                            <SettingsIcon />
                                        </span>
                                    </Tooltip>
                                </Box>
                            </>
                        )}

                    </Box>
                </>
            )}
            {isLoading && (
                <Loader
                    title='Подготовка списка. Это займет несколько секунд.'
                />
            )}
            {!isLoading && !isDownload && (
                <>
                    <Box className={appStyles.iconSort}>
                        <span onClick={handleOpenSearch} className={`${openSearch ? appStyles.iconSelected : ''}`}><SearchIcon /></span>
                    </Box>
                    <ModalWidget
                        open={open}
                        handleClose={handleClose}
                        title="Настройка полей таблицы"
                        closeIconPosition="right"
                        showAcceptButton
                        showCancelButton
                        onAccept={handleAccept}
                        onCancel={handleReset}
                        widthProps={650}
                    >
                        <TransferList
                            key={JSON.stringify(tempFields)}
                            defaultFields={tempFields}
                            allFields={allFields}
                            onFieldsChange={handleTempFieldsChange}
                        />
                    </ModalWidget>

                    {openSearch && (
                        <TextField
                            label="Поиск"
                            variant="outlined"
                            value={searchQuery}
                            onChange={handleSearchChange}
                            fullWidth
                            margin="normal"
                        />
                    )}
                    {insuredPersons.length > 0 && filteredInsuredPersons.length > 0 ? (
                        <Box>

                            <Box sx={{
                                width: '100%',
                                overflow: 'hidden',
                                position: 'relative'
                            }}>
                                <List
                                    title={fields}
                                    data={paginatedInsuredPersons()}
                                    renderItem={renderItem}
                                    renderPagination={filteredInsuredPersons.length > 10}
                                    pageCount={Math.ceil(filteredInsuredPersons.length / 10)}
                                    onAction={handleChildAction}
                                    currentPage={currentPage}
                                    pathnameProps="/insured-persons/case/"
                                    link={true}
                                />
                            </Box>
                        </Box>
                    ) : (
                        <Box className={appStyles.infoBox}>
                            <p>Застрахованные не найдены</p>
                        </Box>
                    )}
                </>

            )}

        </>
    );
};

export default InsuredPersons;
